// extracted by mini-css-extract-plugin
export var callCard = "_mw-0";
export var callMessageButton = "_mw-1";
export var helpIcon = "_mw-3";
export var helpIconContainer = "_mw-4";
export var verticalDivider = "_mw-2";